import { render, staticRenderFns } from "./buildingList.vue?vue&type=template&id=7489ef42&"
import script from "./buildingList.vue?vue&type=script&lang=js&"
export * from "./buildingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports